import { createSelector } from "reselect";
import { config as selectConfig } from "../state/config/config.selector";
import { getShareLink } from "../utils/url.helpers";

export const selectShareLink = createSelector(
  [selectConfig, (_config, workspaceId: string = "") => workspaceId],
  (config, workspaceId) => getShareLink(workspaceId, config),
);
